import { useEffect, useState } from "react";

const useRestaurantsMenu = (resId) => {
  const [resMenuInfo, setResMenuInfo] = useState(null);
  useEffect(() => {
    fetchMenuItems();
  }, []);

  const fetchMenuItems = async () => {
    const data = await fetch(
      `https://www.swiggy.com/dapi/menu/pl?page-type=REGULAR_MENU&complete-menu=true&lat=28.7040592&lng=77.10249019999999&restaurantId=${resId}&catalog_qa=undefined&submitAction=ENTER`
    );

    const json = await data.json();

    setResMenuInfo(json.data);
  };

  return resMenuInfo;
};

export default useRestaurantsMenu;
